export default __webpack_public_path__ + "static/media/mugT.fb8eb887.jpg";